'use strict';

var MySerieDefaultOptions = {
	zIndex: 90,
	dataGrouping: {
		enabled: false
	},
	turboThreshold: 0,
	threshold: null,
	shadow: false,
	animation: false,
	stacking: null,
	connectNulls: true
};

// #$MySerie
var MySerie = (function () {
	function MySerie(chart, userConfig) {
		_classCallCheck(this, MySerie);

		this.config = userConfig;
		this.chart = chart;
		this.init();
	}

	_createClass(MySerie, [{
		key: "init",
		value: function init() {

			var config = this.config,
				id = config.id,
			    chart = this.chart,
			    options = merge(MySerieDefaultOptions, config);

			options.allowedTypes = this.allowedTypes();

			if (options.allowedTypes.indexOf(options.type) < 0) {
				options.type = "line"; /*'area'*/
			}

			options.color = config.myColor;

			function generateStaticColorOpts(options, color) {

				if (!saveUserSelections[id].color) saveUserSelections[id].color = color;
				else color = saveUserSelections[id].color;

				if (options) {
					options.color = color;
					options.fillColor = {
						linearGradient: {
							x1: 0,
							y1: 0,
							x2: 0,
							y2: 1
						},
						stops: [[0, color], [1, Highcharts.Color(color).setOpacity(0).get('rgba')]]
					};
					options.fillOpacity = null;
					options.myColor = null;
					return options;
				}
				return false;
			}
			
			if (options.type == 'area' || options.type == 'line') {
				options = generateStaticColorOpts(options, '#2962FF');
			}

			if (options.type == 'area') {
				for (var ele in this.config.data) {
					if (this.config.data[ele].low != undefined) {
						this.config.data[ele].l = this.config.data[ele].low;
						this.config.data[ele].o = this.config.data[ele].open;
						this.config.data[ele].h = this.config.data[ele].high;
						this.config.data[ele].c = this.config.data[ele].close;

						delete this.config.data[ele].low;
						delete this.config.data[ele].open;
						delete this.config.data[ele].high;
						delete this.config.data[ele].close;
					}
				}
			}
	//Fill the closing line and background of red candles
			if (options.type == "candlestick" || options.type == "ohlc") {
				options.color = '#EF5350' 
			}

			this.chart.prevType = options.type;
			chart.addSeries(options);
		}
	}, {
		key: "update",
		value: function update(toUpdate, redraw) {
			var config = this.config,
			    chart = this.chart;
			isFirstCall = false;

			if (toUpdate.color) {
				this.config.myColor = toUpdate.color;

				toUpdate.fillColor = {
					linearGradient: {
						x1: 0,
						y1: 0,
						x2: 0,
						y2: 1
					},
					stops: [[0, toUpdate.color], [1, Highcharts.Color(toUpdate.color).setOpacity(0).get('rgba')]]
				};
			};

			if (toUpdate.type && (toUpdate.type == 'candlestick' || toUpdate.type == 'ohlc')) {
				toUpdate.color = '#C0392B';
			} else {
				toUpdate.color = this.config.myColor;
			}
			if (log) console.log("config id ",chart)
			if(chart.get(config.id)!= undefined){
				chart.get(config.id).update(toUpdate, redraw);
			}
			try{ chartTitle(_th.chart.series); }catch(err){ console.log("Something went wrong with chart title update.") }

		}
	}, {
		key: "s",
		value: function s() {
			return this.chart.get(this.config.id);
		}
	}, {
		key: "allowedTypes",
		value: function allowedTypes() {
			return this._allowedTypes = ['line', 'area', 'candlestick', 'ohlc'];
		}
	}, {
		key: "updateLastBar",
		value: function updateLastBar(obj) {
			//console.log(obj.pch)
			var serie = this.s(),
			    data = serie.data,
			    newHigh = obj.high || obj.one_sec_high || obj.p,
			    newLow = obj.low || obj.one_sec_low || obj.p,
			    lastBar = data[data.length - 1],
					prevBar = data[data.length - 2],
				x = lastBar.x,
				y = obj.p,
			    open = lastBar.open,
			    high = lastBar.high,
			    low = lastBar.low,
			    close = obj.p;

			if (!lastBar.open) {
				var aux = serie.options.data[serie.options.data.length - 1];
				open = aux.open;
				high = aux.high;
				low = aux.low;
			}

			if (newHigh > high) {
				high = newHigh;
			}
			if (newLow < low) {
				low = newLow;
			}

			lastBar.change = lastBar.y - prevBar.y 
			lastBar.percentChange = -(((prevBar.y-lastBar.y)/prevBar.y) * 100)

			if(this.chart.prevType == "line" || this.chart.prevType == "area") {
				if (lastBar.open) {
					lastBar.update([x, y, open, high, low, close], true);
				} else {
					lastBar.update([x, y, close], true);
				}
				serie.options.data[serie.options.data.length - 1] = [x, y, open, high, low, close];
			}
			else {
				// UPDATE LAST BAR VALUE AND COLOR LABEL AND CLOSING LINE OF CHARTS DIFFERENT THAN LINE AND AREA
				if (lastBar.open) {
					lastBar.update([x, open, high, low, close], true);
				} else {
					lastBar.update([x, close], true);
				}

				if(lastBar.close > lastBar.open){ //POSITIVE
					$(".iChart-plotLabel").addClass("closeLabelPositive");
					$(".closeLine").addClass("closeLinePositive");

					$(".iChart-plotLabel").removeClass("closeLabelNegative");
					$(".closeLine").removeClass("closeLineNegative");
				}else{ //NEGATIVE
					$(".iChart-plotLabel").removeClass("closeLabelPositive");
					$(".closeLine").removeClass("closeLinePositive");

					$(".iChart-plotLabel").addClass("closeLabelNegative");
					$(".closeLine").addClass("closeLineNegative");
				}

				serie.options.data[serie.options.data.length - 1] = [x, open, high, low, close];
			}

		}
	}, {
		key: "addBar",
		value: function addBar(obj, redraw, cdata) {
			var serie = this.s(),
			    data = serie.data,
			    val = obj.p,
			    high = obj.high || obj.one_sec_high || val,
			    low = obj.low || obj.one_sec_low || val,
			    open = obj.open || obj.one_sec_open || val,
			    bar = {
				open: open,
				high: high,
				low: low,
				close: val,
				y: val
			},
			    lastBar = data[data.length - 1],
			    dif = lastBar.x - data[data.length - 2].x,
			    new_dt = lastBar.x + dif,
			    aux_dif = obj.dt - lastBar.x,
			    aux_n = 1,
				aux_count = Math.floor(aux_dif / dif);


			if(cdata.agr == "1m" && 60000 < (obj.dt - lastBar.x) && (obj.dt - lastBar.x) < 120000){

				bar.x = lastBar.x + 60000;

			} else if(cdata.agr == "1m" && serie.options.id == 'null:cur'){
				bar.x = lastBar.x + 60000;

			} else {
				if (aux_count > 1) {
					aux_n = aux_count;
				}

				new_dt = lastBar.x + dif * aux_n;;
				bar.x = new Date(new_dt).getTime();

			}

			serie.addPoint({
				x: bar.x,
				open: bar.open,
				high: bar.high,
				low: bar.low,
				close: bar.close
			}, false, true);

			serie.isDirty = true;
			serie.isDirtyData = true;

			if (redraw) {
				serie.redraw();
			}
		}
	}, {
		key: "remove",
		value: function remove() {
			var config = this.config,
			    id = config.id,
			    chart = this.chart;

			var me = chart.get(id);
			if (me) {
				me.remove();
			}
		}
	}]);

	return MySerie;
})();
//end MySerie class